import { Rating } from '@mui/material'
import React from 'react'

export const ShopRating = ({product}) => {
  return (
    <div>
            <div className='text-center text-lg text-gray-600'>5 reviews for {product[0]?.prdname}</div>
            <div className='rating-box-main'>
                <div className='ratingbox-1 bg-gray-100 mt-2'>
                    <div className='text-5xl font-semibold mt-5'>5.0</div>
                    <div>
                        {product[0]?.rating ? (
                            <span>
                                <Rating
                                    name="read-only"
                                    value={product[0]?.rating}
                                    size='small'
                                    className="mt-1"
                                />
                            </span>
                        ) : (
                            <span>
                                <Rating
                                    name="read-only"
                                    // value={x.rating}
                                    size='small'
                                    className="mt-1"
                                />
                            </span>
                        )}
                    </div>
                    <div className='text-gray-600'>Based on 5 reviews</div>
                </div>
                {/* <div className='ratingbox-2 p-5'>
                    <div className='flex'>
                        <p>5 Star</p>
                        <p className='border py-2 px-5 w-60 bg-gray-600 mx-5'></p>
                        <p>100%</p>
                    </div>
                    <div className='flex  mt-2'>
                        <p>4 Star</p>
                        <p className='border py-2 px-5 w-60 bg-gray-100 mx-5'></p>
                        <p>0%</p>
                    </div>
                    <div className='flex  mt-2'>
                        <p>3 Star</p>
                        <p className='border py-2 px-5 w-60 bg-gray-100 mx-5'></p>
                        <p>0%</p>
                    </div>
                    <div className='flex  mt-2'>
                        <p>2 Star</p>
                        <p className='border py-2 px-5 w-60 bg-gray-100 mx-5'></p>
                        <p>0%</p>
                    </div>
                    <div className='flex  mt-2'>
                        <p>1 Star</p>
                        <p className='border py-2 px-5 w-60 bg-gray-100 mx-5'></p>
                        <p>0%</p>
                    </div>
                </div> */}
            </div>
        </div>
  )
}
